<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createCompany.addressInformationForm.title'|translate}}</h3>
      <h5> {{'createCompany.addressInformationForm.subtitle'|translate}}</h5>
    </div>
    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.companyName" class="w-100"
                       [label]="'createCompany.addressInformationForm.companyName'|translate"
                       [showInfo]="true"
                       [header]="'infoIcon.companyGroup.header'|translate"
                       [mainContent]="'infoIcon.companyGroup.content'|translate"
                       [isAbove]="false"
                       [isCentered]="false"
                       [marginValue]="2.2">
        <input name="companyName"
               formControlName="companyName"
               class="input">
      </app-input-field>
    </div>

    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.street" class="bigger-input"
                       [label]="'createCompany.addressInformationForm.street'|translate">
        <input name="street"
               formControlName="street"
               class="input">
      </app-input-field>

      <app-input-field [control]="formGroup.controls.houseNumber" class="smaller-input"
                       [label]="'createCompany.addressInformationForm.houseNumber'|translate">
        <input name="houseNumber"
               formControlName="houseNumber"
               class="input">
      </app-input-field>
    </div>

    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.postalCode" class="smaller-input"
                       [label]="'createCompany.addressInformationForm.postalCode'|translate">
        <input name="postalCode"
               formControlName="postalCode"
               type="text"
               class="input">
      </app-input-field>

      <app-input-field [control]="formGroup.controls.location" class="bigger-input"
                       [label]="'createCompany.addressInformationForm.location'|translate">
        <input name="location"
               formControlName="location"
               class="input">
      </app-input-field>
    </div>
    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.countryCode" class="smaller-input"
                       [label]="'createCompany.addressInformationForm.countryCode'|translate">
        <mat-select formControlName="countryCode"
                    [value]="formGroup.value.countryCode"
                    class="countryCode input">
          <mat-option *ngFor="let opt of QuestionOptions.countryCodes"
                      [value]="opt">{{opt}}</mat-option>
        </mat-select>
      </app-input-field>

      <app-input-field [control]="formGroup.controls.countryCode" class="bigger-input"
                       [label]="'createCompany.addressInformationForm.country'|translate">
        <mat-select formControlName="countryCode" class="country input" [value]="formGroup.value.countryCode">
          <mat-option *ngFor="let opt of QuestionOptions.countryCodes"
                      [value]="opt">{{'countryCodes.' + opt | translate}}</mat-option>
        </mat-select>
      </app-input-field>
    </div>
  </div>
</form>
